import React, { Fragment } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  ReferenceLine,
  Tooltip
} from "recharts";

import { connect } from "react-redux";
import Loader from "../../../Loader/Loader.js";
import {
  selectFormat,
  ComponentWithUrl,
  StandardTooltip
} from "./../../../Utils/Utils.js";

class VisitorsByMonth extends ComponentWithUrl {
  constructor(props) {
    super(props);
    this.state = {
      time_span: "day"
    };
  }

  render() {
    const { loading, data } = this.props;

    if (loading) {
      return <Loader minHeight={100} col={"col-12"} size="circle-scale--sm" />;
    }
    return (
      <ResponsiveContainer height={100} width="100%">
        <BarChart
          width={150}
          height={100}
          data={data}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                render={({ data }) => {
                  const payload = data(this.props);
                  if (payload !== null) {
                    return (
                      <div className="standard-tooltip">
                        {Object.keys(payload).map(key => (
                          <Fragment key={key}>
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Month:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {payload[key].payload.fullName}
                              </span>
                            </header>

                            <main className="standard-tooltip__main">
                              <div className="standard-tooltip__item" key={key}>
                                <span className="standard-tooltip__key">
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{ background: "#FA6E57" }}
                                  ></span>
                                  {payload[key].payload.fullName}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat("number", payload[key].value)}
                                </span>
                              </div>
                            </main>
                          </Fragment>
                        ))}
                      </div>
                    );
                  }
                }}
              />
            }
          />

          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
              <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
            </linearGradient>
          </defs>

          <Bar
            dataKey="count"
            fillOpacity={1}
            fill="url(#colorUv)"
            background={this.props.background && { fill: "#eee" }}
          />
          {this.props.goal && (
            <ReferenceLine
              y={this.props.goal}
              label=""
              stroke="#fc6d52"
              strokeDasharray="3 3"
            />
          )}
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ strokeWidth: 0, fill: "#25263F" }}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = (state, props) => {
  if (props.noUrl) {
    return {
      data: props.data,
      loading: false
    };
  }

  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true
  };
};

export default connect(mapStateToProps)(VisitorsByMonth);
